// extracted by mini-css-extract-plugin
export default {"qrcode":"QrCodeViewer_qrcode__kb5zZ"};